import { Link } from "react-router-dom";
import { Truck } from "lucide-react";
import { useBusiness } from "@/context/BusinessContext";

export const AuthShell = ({ eyebrow, title, subtitle, children, footer }) => {
  const { profile } = useBusiness();
  return (
    <div className="min-h-screen bg-[#030712] cyber-grid relative flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 scanlines" />
      <div className="relative w-full max-w-md rise-in">
        <Link to="/" className="flex items-center gap-2.5 mb-8" data-testid="auth-home-link">
          <span className="grid place-items-center w-9 h-9 border glow-cyan text-cyan-300"><Truck className="w-4 h-4" /></span>
          <span className="font-display font-bold tracking-widest uppercase text-sm">{profile?.company_name || "Towing"}</span>
        </Link>
        <div className="border bg-[#070B16]/95 p-6 sm:p-8 glow-cyan hud-corner relative">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#00FF66]">// {eyebrow}</p>
          <h1 className="font-display text-2xl sm:text-3xl uppercase tracking-wider mt-3 text-white">{title}</h1>
          <p className="text-sm text-slate-400 mt-2 mb-8">{subtitle}</p>
          {children}
        </div>
        {footer && <div className="mt-6 text-center">{footer}</div>}
      </div>
    </div>
  );
};
